import { IHeadCountFixupSlice } from './interface';

export const headCountFixupSliceInitialState: IHeadCountFixupSlice = {
    showHeadCountFixupRequiredModal: false,
    showHeadCountFixupPage: false,
    fixup: {
        originalRecord: {},
        recordsToUpdate: [],
        recordsToDelete: [],
        feedingDistributionsToOverride: [],
        lastAuditDateFixupGot: '',
    },
    initialHistory: {
        lotId: 0,
        endDate: '',
        startDate: '',
        lotPensForLot: [],
        moveTypeRecordPenHeadCountChanges: [],
        lastAuditCreatedDatetime: '',
    },
    recordRowsAfterFixupByDate: {},
    lotPensAfterFixupByDate: {},
    formChanged: false,
};
